<template lang="pug">
  header
    .sticky-mobile-bar(:class="stickyHeaderClass")
      button.hamburger.hamburger--3dy(
        type="button"
        :class="{ 'is-active': sidebar }"
        @click="toggleSidebar"
      )
        span.hamburger-box
          span.hamburger-inner
      ShoppingCart
    Menu#header-menu(k="header-menu" :max-depth="1")
    .flex.w-full.my-8
      .logo(v-if="isHomepage")
          img(v-if="logo && logo.id" :src="image.src" title="logo" rel="noopener")
          img(v-else src="@/assets/logo.png")
      .logo(v-else)
          router-link(:to="{ path: '/'}")
            img(v-if="logo && logo.id" :src="image.src" title="logo" rel="noopener")
            img(v-else src="@/assets/logo.png")
      Menu#main-menu(k="main-menu" :max-depth="3")
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

import { trim } from '@/helpers';

import Menu from '@/components/Menu.vue';
import ShoppingCart from '@/extensions/shop/components/ShoppingCart.vue';

export default {
    name: 'Header',
    data: () => ({
        lastScroll: 0,
        stickyHeaderClass: ''
    }),
    components: {
        Menu,
        ShoppingCart
    },
    computed: {
        isHomepage() {
            if (this.$route.path == '/') {
                return true;
            } else {
                return false;
            }
        },
        image() {
            const storageRoute = trim(
                `${process.env.VUE_APP_API_HTTP}${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE}`,
                '/'
            );

            const fit = 'fit=fill&w=350&h=150';

            let width = this.logo.width;
            let height = this.logo.height;

            return {
                src: `${storageRoute}/images/${this.logo.id}/${this.logo.name}?${fit}`,
                error: `${storageRoute}/images/${this.logo.id}/${this.logo.name}?${fit}&preview=greyscale`,
                loading: `${storageRoute}/images/${this.logo.id}/${this.logo.name}?${fit}&preview=blur`,
                width,
                height
            };
        },
        ...mapGetters({
            logo: 'logo',
            menus: 'menus',
            sidebar: 'sidebar'
        })
    },
    methods: {
        openSearch() {
            console.log('open search bar');
        },
        toggleSidebar() {
            this.updateSidebarVisibility(!this.sidebar);
        },
        updateStickyHeader() {
            const currentScroll = window.pageYOffset;

            const scrollUp = 'scroll-up';
            const scrollDown = 'scroll-down';

            if (currentScroll > this.lastScroll && this.stickyHeaderClass !== scrollDown) {
                this.stickyHeaderClass = scrollDown;
            } else if (currentScroll < this.lastScroll && this.stickyHeaderClass !== scrollUp) {
                this.stickyHeaderClass = scrollUp;
            }

            this.lastScroll = currentScroll;
        },
        ...mapMutations({
            updateSidebarVisibility: 'updateSidebarVisibility'
        })
    },
    mounted() {
        window.addEventListener('scroll', this.updateStickyHeader);
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.updateStickyHeader);
    }
};
</script>

<style lang="sass" nolang="scss" scoped>
@import "~@/assets/sass/variables"

header
  display: flex
  // justify-content: space-between
  align-items: center
  font-weight: 400
  justify-content: flex-end
  flex-direction: column
  padding-top: 53px
  @screen lg
    padding-top: 0
  .logo
    padding: 1rem
    margin-left: 2rem
    img
      max-height: 90px
      max-width: 235px
  .flex
    justify-content: center
    margin-top: 0
    border-bottom: 5px solid $color-adenauer-orange
    @screen lg
      justify-content: initial

    ::v-deep
      .search
        flex-grow: 0
        flex-shrink: 0
        flex-basis: 60px
        button
          @apply text-black
          width: 24px
          height: 38px
          font-size: 2rem
          line-height: 0

    #main-menu
      @apply hidden
      @screen lg
        @apply flex
      &::v-deep
        ul
          @apply flex items-center
          &.tree-menu
            & > li
              @apply relative
              &.visible.hover.has-children
                > .tree-item a
                  color: $color-adenauer-orange

              &:last-of-type > .tree-item a
                @apply mr-0

              &:not(.full-width)
                @apply relative

              & > .tree-item a
                @apply font-normal mx-4
                transition: color .15s ease, border-color .3s ease
                color: $color-adenauer-blue
                font-size: 20px
                .down
                  @apply ml-2
                  font-size: 16px

                &:hover
                  color:$color-adenauer-orange
                & > .active
                  @apply text-white
              li
                @apply w-full bg-white px-3

                &:last-of-type > .tree-item a
                  @apply border-0

                & > .tree-item a
                  @apply font-normal block max-w-md p-2 normal-case m-0 border-b border-solid
                  color: $color-adenauer-blue
                  font-size: 18px
                  border-color: #e5e5e5
                  .ancor
                    width: 15px
                    height: 21px
                    margin-top: 3px
                    margin-right: 10px
                    float: left

                  &:hover
                    color: $color-adenauer-orange !important
                &.hover
                  & > .tree-item a
                    color: $color-adenauer-orange
        & > ul
          &.tree-menu
            & > li
              display: inline-block
              white-space: nowrap
              & > ul
                &.tree-menu
                  @apply absolute z-50 inline-block max-w-md left-0 shadow-sm
                  top: 80px
                  min-width: 350px
            ul ul
              @apply absolute top-0
              min-width: 350px
              margin-bottom: 9px
              right: 0

        .show-enter-active, .show-leave-active
          transition: opacity 0.3s ease, transform 0.3s ease
          transform-origin: left center
        .show-enter, .show-leave-to
          opacity: 0
          transform: translateY(6px)

  .sticky-mobile-bar
    @apply flex justify-between items-center
    position: fixed
    top: 0
    left: 0
    width: 100%
    background: rgba(255, 255, 255, .8)
    backdrop-filter: blur(20px)
    transition: transform .15s linear
    z-index: 10
    @screen lg
      @apply hidden
    &.scroll-down
      transform: translateY(-54px)
    .hamburger
      height: 53px
      padding: 1rem
    .shopping-cart
      padding: 0 1rem
</style>
